import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

function CatSpace() {
    return (
        <svg
            className="fill-white h-full w-full"
            width="577"
            height="512"
            viewBox="0 0 577 512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M545 160C545 230.7 487.7 288 417 288C346.3 288 289 230.7 289 160C289 127.5 301.1 97.9 321 75.3V160C321 213 364 256 417 256C470 256 513 213 513 160V75.3C532.9 97.9 545 127.5 545 160ZM380.2 89.6L350.8 50.4C370.1 38.7 392.8 32 417 32C441.2 32 463.9 38.7 483.2 50.4L453.8 89.6C450.8 93.6 446 96 441 96H393C388 96 383.2 93.6 380.2 89.6ZM449 316.8C522 302 577 237.4 577 160C577 71.6 505.4 0 417 0C328.6 0 257 71.6 257 160C257 171.7 258.3 183.1 260.6 194.1C205.7 202.2 158.4 233.6 129 277.9V192.6C129 144.2 92.9 103.3 44.9 97.3L37 96.3C19.4 94.1 3.4 106.5 1.2 124C-0.999999 141.5 11.4 157.5 29 159.7L36.9 160.7C52.9 162.7 64.9 176.3 64.9 192.5L65 416C65 469 108 512 161 512H305C322.7 512 337 497.7 337 480C337 462.3 322.7 448 305 448H249L385 339.2V480C385 497.7 399.3 512 417 512C434.7 512 449 497.7 449 480V316.8ZM369 160C369 155.757 370.686 151.687 373.686 148.686C376.687 145.686 380.757 144 385 144C389.243 144 393.313 145.686 396.314 148.686C399.314 151.687 401 155.757 401 160C401 164.243 399.314 168.313 396.314 171.314C393.313 174.314 389.243 176 385 176C380.757 176 376.687 174.314 373.686 171.314C370.686 168.313 369 164.243 369 160ZM449 144C453.243 144 457.313 145.686 460.314 148.686C463.314 151.687 465 155.757 465 160C465 164.243 463.314 168.313 460.314 171.314C457.313 174.314 453.243 176 449 176C444.757 176 440.687 174.314 437.686 171.314C434.686 168.313 433 164.243 433 160C433 155.757 434.686 151.687 437.686 148.686C440.687 145.686 444.757 144 449 144Z" />
        </svg>
    );
}

type ErrorPageProps = {
    statusCode?: string;
    title?: string;
    description?: string;
    actionTo?: string;
};

export default function ErrorPage({ statusCode, title, description }: ErrorPageProps) {
    const { t } = useTranslation();
    return (
        <div
            className="bg-black h-full overflow-hidden w-full text-white p-10 lg:pl-64"
            id="error-page"
        >
            <div className="h-2/3 flex flex-col justify-center z-20 space-y-4">
                <div className="text-9xl font-extralight">{statusCode}</div>
                <div className="text-primary text-3xl font-medium">
                    {title ?? t("error.maintext")}
                </div>
                <div className="text-2xl">{description ?? t("error.secondtext")}</div>
                <Link
                    to="/"
                    className="text-md border-primary border-2 rounded-xs px-4 py-1 w-fit hover:bg-primary hover:text-black ease-in-out transition-colors duration-100"
                >
                    {t("error.helpout")}
                </Link>
            </div>
            <div className="absolute lg:right-100 h-12 w-92 -z-1 animate-spaceOrbit">
                <div className="animate-spaceOrbit2 h-40 w-12">
                    <div className=" animate-spaceCat h-12 w-12 rotate-[28.62deg]">
                        <CatSpace />
                    </div>
                </div>
            </div>
        </div>
    );
}
